import React from "react";
import { Container } from "@prestosports/commons-ui";
import { useGameContext } from "../../../state/game/context";
import { useGameContextContext } from "../../../state/game-context/context";
import BallPosition from "../components/BallPosition";
import MissingGameDataContainer from "../../game/containers/MissingGameDataContainer";
import PlayStepper from "../components/PlayStepper";
import GameStartContainer from "./GameStartContainer";
import playSequenceContainerStyles from "../styles/PlaySequenceContainer.styles";

const PlaySequenceContainer = () => {
	const classes = playSequenceContainerStyles();
	const { state: gameState } = useGameContext();
	const game = gameState.game();
	const isLoading = gameState.isLoading();

	const { state: gameContextState } = useGameContextContext();
	const isGameInitialized = gameContextState.isGameInitialized();
	const missingGameData = gameContextState.missingGameData();
	const isGameContextLoading = gameContextState.isLoading();

	return (
		!isLoading &&
		!isGameContextLoading &&
		game && (
			<Container fullHeight noPaper>
				<>
					{isGameInitialized && !missingGameData.length && (
						<>
							<div className={classes.ballPosition}>
								<BallPosition />
							</div>
							<div className={classes.stepper}>
								<PlayStepper />
							</div>
						</>
					)}
					{!isGameInitialized && !missingGameData.length && <GameStartContainer />}
					{!!missingGameData.length && <MissingGameDataContainer />}
				</>
			</Container>
		)
	);
};

export default PlaySequenceContainer;
